import { render, staticRenderFns } from "./JobPage.vue?vue&type=template&id=c5083ed6&scoped=true"
import script from "./JobPage.vue?vue&type=script&lang=js"
export * from "./JobPage.vue?vue&type=script&lang=js"
import style0 from "./JobPage.vue?vue&type=style&index=0&id=c5083ed6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5083ed6",
  null
  
)

export default component.exports